import React from 'react';
import { NavLink } from 'react-router-dom';

const MENU = [
    { to: '/dashboard', icon: 'fa-tachometer', label: 'Dashboard' },
    { to: '/item-manager', icon: 'fa-cubes', label: 'Item Manager' },
    { to: '/vendor-compare', icon: 'fa-balance-scale', label: 'Vendor Compare' },
    { to: '/doc-upload', icon: 'fa-cloud-upload', label: 'Doc Upload' },
];

const Sidenavbar = () => {
    return (
        <div className="SidenavBar">
            <ul>
                {MENU.map(menu => (
                    <li key={menu.to}>
                        <NavLink to={menu.to}>
                            <span><i className={`fa ${menu.icon}`} aria-hidden="true"></i></span> {menu.label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default Sidenavbar
